<template>
  <v-container fluid>
    <v-row class="bgcObrigado">
      <v-col cols="12" md="12" class="flex-column d-flex justify-center align-center">
        <h1>Obrigado por se cadastrar</h1>
        <p>
          Em breve enviaremos um e-mail com as novidades da
          Ribus.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
p { 
  color:#fff;
  font-size: 18px; font-weight: 300
}
h1 { 
  font-family: Poppins;
  color: #fff;
  font-weight: 500;
  text-align: center;
  line-height: 1;
}
.bgcObrigado {
  background-image: url("../assets/capacadastro.jpg");
  background-repeat: no-repeat;
  height: calc(100vh - 74px);
  background-size: cover;
  background-position: center;
}
</style>
<script>

export default {
  name:"Obrigado",
  metaInfo: {
    title: "Obrigado",
  },

  mounted() {
        window.scrollTo(0, 0);
  }
}
</script>

